import React from "react";
import ContentLoader from "react-content-loader";
import { Color } from "../../enums/Color";

interface Props { 
  count: number;        // number of boxes
  height?: number;      // height of each box
  gapPercent?: number;  // spacing between boxes in
}

export const SelectLoader: React.FC<Props> = ({ 
 count, 
 height = 60,
 gapPercent = 10
}) => {
  
  const totalGaps = (count - 1) * gapPercent;
  const boxWidthPercent = (100 - totalGaps) / count;

  return (
    <div style={{ width: "100%", overflow: "hidden", padding:"36px 0 0 0"}}>
      <ContentLoader
        speed={1}
        width="100%"
        height={height}
        backgroundColor={Color.LoaderBackground}
        foregroundColor={Color.LoaderForeground}
        viewBox="0 0 100 60"
        preserveAspectRatio="none"
      >
        {[...Array(count)].map((_, i) => (
          <rect
            key={i}
            x={i * (boxWidthPercent + gapPercent)} 
            y={0}
            rx={0}
            ry={0}
            width={boxWidthPercent}
            height={height}
          />
        ))}
      </ContentLoader>
    </div>
  );
};
